var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveDropOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fu3q92jrpa",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D01400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f9b90l8w9b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EA2D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#D01400"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-113 -513) translate(16 212) translate(16 301) translate(81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "url(#fu3q92jrpa)",
    opacity: 0.16,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    fill: "url(#f9b90l8w9b)",
    fillRule: "nonzero",
    transform: "translate(1.164 2.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.825 12.019c-.526 0-.808-.405-.808-.977v-3.07H3.94c-.554 0-.939-.306-.939-.849 0-.563.357-.879.939-.879h3.078V2.977c0-.572.282-.977.808-.977.525 0 .844.385.844.977v3.267h3.089c.572 0 .929.316.929.879 0 .543-.376.849-.93.849H8.67v3.07c0 .592-.319.977-.844.977z",
    transform: "rotate(-45 7.843 7.01)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDropOff);
export default __webpack_public_path__ + "static/media/removeDropOff.505a778d5fbda7d777a09a5157031b42.svg";
export { ForwardRef as ReactComponent };